import { NavLink, Outlet } from 'react-router-dom'
import { PageHeader } from '../../../components/ui/PageHeader'
import { useAuth } from '../../../context/AuthContext'
import { PERMISSION_KEYS } from '../../../config/permissions'
import { tabLink, tabsWrapClass } from '../../../lib/ui'

/** Учёт продукции и комплектации по маршруту `/production`. */
export function ProductionLayout() {
  const { can } = useAuth()
  const showProducts = can(PERMISSION_KEYS.PRODUCTS_READ)
  const showConsumables = can(PERMISSION_KEYS.CONSUMABLES_READ)

  return (
    <div>
      <PageHeader
        title="Продукция"
        lead="Учёт готовой продукции и расходников (как ресурсная спецификация: номенклатура, количество, ед. изм., себестоимость)."
      />
      <div className={tabsWrapClass}>
        {showProducts && (
          <NavLink to="/production/products" className={({ isActive }) => tabLink(isActive)}>
            Продукция
          </NavLink>
        )}
        {showConsumables && (
          <NavLink to="/production/consumables" className={({ isActive }) => tabLink(isActive)}>
            Расходники
          </NavLink>
        )}
      </div>
      <div className="mt-5">
        <Outlet />
      </div>
    </div>
  )
}
